/**
 * 使用公司名称查询
 */

import * as React from 'react'
import { companyNameSearch } from '@/services/common'

const { useState } = React

export default function useCompanyNameSearch() {
  const [open, setOpen] = useState<boolean>(false)
  const [companyNameList, setCompanyNameList] = useState<{ value: string }[]>([])

  const onSearch = async (companyName: string = '') => {
    if (!companyName?.trim() || companyName?.length < 2) return
    const { data } = await companyNameSearch({ companyName })
    if (data?.code === 0) {
      const result = data?.result || []
      setOpen(result?.length > 0)
      setCompanyNameList(
        result.map((item: any) => ({ label: item.companyName, value: item.companyName })),
      )
    }
  }

  const onChange = (data: string) => {
    if (!data) {
      setCompanyNameList([])
      setOpen(false)
    }
  }

  const onVisible = (v: boolean) => setOpen(v)

  return {
    open,
    companyNameList,
    onVisible,
    onSearch,
    onChange,
  }
}
